export default __webpack_public_path__ + "static/media/right-purple.3803cd1b.svg";